export const APP_INFO_CONST = {
  IS_LOGIN : 'isLogin',
  TOKEN_KEY : 'accessToken',
  REFRESH_TOKEN_KEY : 'refreshToken',
  SAVE_ID_KEY : 'saveId',
  AUTO_LOGIN_KEY : 'autoLogin',
  PAGE_SIZE : 10,
}